const wallConfigReducer = (state = null, action) => {
  switch(action.type) {
    case 'ON_WALL_CONFIG_CHANGE':
      return {
        ...state,
        [action.key]: action.value
      }
    case 'ON_WALL_CONFIG_COLLECTION_CHANGE':
      var key = action.key;
      var value = action.value;
      return {
        ...state,
        collections: [
          ...state.collections.slice(0, action.index),
          {
            ...state.collections[action.index],
            [key]: value
          },
          ...state.collections.slice(action.index+1)
        ]
      }
    default:
      return state;
  }
};

export default wallConfigReducer

